import "./StartingLocalToGoGlobalCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import CaseHero from "./sections/CaseHero";
import Results from "./sections/Results";
import CaseStudyDetail from "./sections/CaseStudyDetail";
import Footer from "@/reusable_sections/Footer";
export default function StartingLocalToGoGlobalCaseStudyPage() {
  return <div>
      <Header />
      <CaseHero />
      <Results />
      <CaseStudyDetail />
      <Footer />
    </div>;
}